import { FC, memo } from 'react'

import { ArrowRightIcon, Button, Text } from '@cash-me/react-components'
import NextImage from "next/image"

import { Breadcrumb } from 'components/breadcrumb'
import { Grid, Col } from 'components/grid'
import useWindowSize from 'hooks/useWindowSize'

import { HeroProps } from './hero.model'
import * as S from './styles'

const Hero: FC<HeroProps> = memo(({ onClick }) => {
  const { isMobile } = useWindowSize()

  const BreadcrumbLinks = [
    { label: 'Portabilidade de Dívidas' }
  ]

  return (
    <S.Hero>
      <Grid col={{ phone: 1, tablet: 2, desktop: 12 }}>
        <Col col={{ desktop: 4 }} start={{ desktop: 2 }}>
          <S.Content>
            <S.Infos>
              <Breadcrumb items={BreadcrumbLinks} />
              <Text as="h1" size="heading2" weight="medium">
                Portabilidade {''}
                <Text as="span" size="heading2" weight="medium" color="var(--colors-cyan-text-contrast)">
                  de {''}
                  <br />
                  Dívidas
                </Text>
              </Text>
              <Text color="var(--colors-neutral-text-weak)">
                Aproveite nosso empréstimo para quitar uma dívida mais cara e dar crédito à sua vida financeira.
              </Text>
              <Button size="lg" onClick={onClick} variants="default">
                Simular agora <ArrowRightIcon />
              </Button>
            </S.Infos>
          </S.Content>
        </Col>
        {!isMobile && 
          <Col col={{ desktop: 6 }} start={{ desktop: 7 }}>
            <S.ImgWrapper>
              <NextImage
                src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/defaulter/hero-desktop.png`}
                alt="Homem mexendo no tablet"
                width="614"
                height="467"
                quality="100"
                priority
                sizes="100vw"
                style={{
                  width: "100%",
                  height: "auto"
                }} />
            </S.ImgWrapper>
          </Col>
        }
      </Grid>
    </S.Hero>
  );
})

Hero.displayName = 'Hero'

export default Hero
